import React, { useState } from "react";
import { IconButton, Grid, useMediaQuery } from "@mui/material";
import { ChevronLeftRounded, ChevronRightRounded } from "@mui/icons-material";
import rawStyles from "../../styles";
import { useTheme } from "@emotion/react";

function ImageCarousel({ details }) {
  const projectImages = (details?.project_image || []).filter((img) =>
    typeof img?.type === "string" ? img.type.startsWith("image/") : true
  );
  const images = projectImages.length
    ? projectImages
    : details?.default_image || [];
  const [startIndex, setStartIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const styles = rawStyles(isMobile);

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) => Math.min(prev + 1, images.length - 3));
  };

  return (
    <>
      <div style={{ ...styles.rowFlex, justifyContent: "space-between" }}>
        <div style={styles.section_heading}>{images.length} Photos</div>
        <div>
          <IconButton onClick={handlePrev} disabled={startIndex === 0}>
            <ChevronLeftRounded />
          </IconButton>
          <IconButton
            onClick={handleNext}
            disabled={startIndex >= images.length - 3}
          >
            <ChevronRightRounded />
          </IconButton>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Grid
          style={{
            ...styles.rowFlex,
            justifyContent: "flex-start",
            gap: "10px",
            width: "100%",
          }}
        >
          {images.slice(startIndex, startIndex + 3).map((item) => (
            <Grid item key={item.id} xs={4}>
              <img
                src={item.image}
                alt={`Image ${item.id}`}
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
}

export default ImageCarousel;
